import { isNonEmptyString } from '@/utils/checks'

const MINIMUM_INSURANCE_PROVIDER_COUNT = 0
const MINIMUM_INSURANCE_BLOCK_FIELDS = 2

export const shouldDisplayInsuranceBlock = ({
  acceptedInsurance = [],
  insuranceDescription = '',
  verifyInsuranceLink = '',
  phone = ''
}: {
  acceptedInsurance?: string[]
  insuranceDescription?: string
  verifyInsuranceLink?: string
  phone?: string
} = {}): boolean => {
  return (
    [
      acceptedInsurance?.length > MINIMUM_INSURANCE_PROVIDER_COUNT,
      isNonEmptyString(insuranceDescription),
      isNonEmptyString(verifyInsuranceLink) || isNonEmptyString(phone)
    ].filter(Boolean)?.length >= MINIMUM_INSURANCE_BLOCK_FIELDS
  )
}

export default shouldDisplayInsuranceBlock
